"use strict";
import { addEvent } from "./addEvent/addEvent";
import "./colorbox/jquery.colorbox-min.js?";
import "./colorbox/colorbox.scss";
import "./bxslider/jquery.bxslider.js";
import "./bxslider/vendor/jquery.fitvids.js";
import "./bxslider/jquery.bxslider.scss";
// import "./vegas/vegas.js";
// import "./vegas/vegas.scss";
import { videoBg } from "./videoBg/videoBg";
// import "./gmap/gmap3.min.js";
import $ from "jquery";
window.jQuery = $;
window.$ = $;

$.event.special.touchstart = {
  setup: function (_, ns, handle) {
    this.addEventListener("touchstart", handle, { passive: true });
  },
};

document.addEventListener("DOMContentLoaded", DOMContentLoadedStart);
addEvent(window, "load", function () {
  afterLoadStart();
});

/*----- START FUNCTION -----*/
function DOMContentLoadedStart() {
  if (navigator.userAgent.match(/Android|webOS|iPhone|iPod|BlackBerry/i)) {
    $("body").addClass("mobil");
  }
  target_blank();
  powieksz_zdjecie();
  akceptacja_ciasteczka();
}

function afterLoadStart() {
  mobile_menu();
  baner_glowny();
  // hasla_glowna();
  setTimeout(() => {
    setFooterHeight();
    backgroundImagesShow();
  }, 100);

  if (!navigator.userAgent.match(/Android|webOS|iPhone|iPod|BlackBerry/i)) {
    setTimeout(() => {
      // videoBg();
    }, 200);
  }

  let scroll = $(window).scrollTop();

  if (scroll >= 10) {
    $("body").addClass("menu-stick");
  } else {
    $("body").removeClass("menu-stick");
  }
}

$(window).on("resize", resize);
$(window).on("scroll", scroll);

function resize() {
  setFooterHeight();
  mobile_menu();
  backgroundImagesShowHeight();
}

function scroll() {
  let scroll = $(window).scrollTop();

  if (scroll >= 10) {
    $("body").addClass("menu-stick");
  } else {
    $("body").removeClass("menu-stick");
  }
}

/*----- CODE HERE -----*/

function target_blank() {
  $("a.out").attr("target", "blank");
}

/*----- BACKGROUND IMAGES SHOW -----*/

function backgroundImagesShow() {
  const mainContainer = "#background-images-show";
  const imgToSlidShow = $("body").attr("data-slids");
  const imgToSlidShowArray = imgToSlidShow.split(",");
  let startElement = 0;
  const intervalTime = 5000;

  if (imgToSlidShowArray.length === 0) {
    return false;
  }

  backgroundImagesShowHeight();

  $(imgToSlidShowArray).each((i) => {
    const addElement = `
        <div class="img-container"
          style="
            background: url(${imgToSlidShowArray[i]}) no-repeat center center; 
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
            filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='${imgToSlidShowArray[i]}', sizingMethod='scale');
            -ms-filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='${imgToSlidShowArray[i]}', sizingMethod='scale');
          "
        >
        </div>
      `;

    $(mainContainer).append(addElement);
  });

  const slides = $(mainContainer).children();

  $(slides[startElement]).addClass("show");

  if (imgToSlidShowArray.length <= 1) {
    return;
  }

  setInterval(() => {
    let next = startElement + 1;
    if (next >= slides.length) {
      next = 0;
    }

    $(slides[next]).addClass("show");
    $(slides[startElement]).addClass("hide").removeClass("show");
    startElement = next;

    setTimeout(() => {
      $(mainContainer).find(".hide").removeClass("hide");
    }, 1100);
  }, intervalTime);
}

function backgroundImagesShowHeight() {
  if ($("body").hasClass("strona-glowna") || 1 == 1) {
    return false;
  }
  const mainContainer = "#background-images-show";
  let $mainHeaderKontaktHeight = $(".main-header-kontakt").outerHeight(true);
  let $mainHeaderHeight = $(".main-header").outerHeight(true);
  let $mainArticleTitleHeight = $(".main-article-title").outerHeight(true);
  let $mainArticleTitleDiscriptionHeight = $(
    ".main-article-title-discription"
  ).outerHeight(true);

  if ($mainHeaderKontaktHeight == undefined) {
    $mainHeaderKontaktHeight = 0;
  }
  if ($mainHeaderHeight == undefined) {
    $mainHeaderHeight = 0;
  }
  if ($mainArticleTitleHeight == undefined) {
    $mainArticleTitleHeight = 0;
  }
  if ($mainArticleTitleDiscriptionHeight == undefined) {
    $mainArticleTitleDiscriptionHeight = 0;
  }

  let $heightContainer =
    $mainHeaderKontaktHeight +
    $mainHeaderHeight +
    $mainArticleTitleHeight +
    $mainArticleTitleDiscriptionHeight +
    20;

  $(mainContainer).height($heightContainer);
}
/*----- MENU MOBILNE -----*/

function mobile_menu() {
  const breakPoint = 1335;
  const szerWin = $(window).width();

  if (breakPoint > szerWin) {
    $("body").addClass("mobile-menu");
    mobileMenuButton(true);
    addFullSiteMenu(true);
  } else {
    $("body").removeClass("mobile-menu");
    mobileMenuButton(false);
    addFullSiteMenu(false);
  }
}

function mobileMenuButton(add) {
  const button = `
          <div class="menu-toggle show-menu">
              <div class="hamburger">
                <span></span>
                <span></span>
                <span></span>
              </div>
          </div>`;

  if (!add) {
    $(".top-header").find(".show-menu").off("click");
    $(".top-header").find(".show-menu").remove();
    $(".top-header").find(".main-nav-header").show();
    return;
  } else {
    $(".top-header").find(".show-menu").remove();
    $(".top-header #h1").after(button);
    $(".top-header").find(".main-nav-header").hide();

    $(".top-header")
      .find(".show-menu")
      .on("click", function () {
        $("body").addClass("mobile-menu-active");
        setTimeout(() => {
          // $(".full-site-menu").getNiceScroll().resize();
        }, 450);
      });
  }
}

function addFullSiteMenu(add) {
  const menu = $(".main-nav-header ul").clone();
  const button = `
      <div class="menu-toggle close-menu">
          <div class="cross">
            <span></span>
            <span></span>
          </div>
      </div>`;
  const menuContainer = `
      <div class="full-site-menu-container">
        ${button}
        <div class="full-site-menu"></div>
      </div>`;

  if (!add) {
    $("body").find(".close-menu").off("click");
    $("body").find(".full-site-menu-container").remove();
  } else {
    if ($("body").find(".full-site-menu-container").length > 0) {
      // $(".full-site-menu").getNiceScroll().resize();
      return false;
    }
    $("body").find(".full-site-menu-container").remove();
    $("body").append(menuContainer);
    $("body").find(".full-site-menu").append(menu);

    fullSideMenuScroll();

    $("body")
      .find(".close-menu")
      .on("click", function () {
        $("body").removeClass("mobile-menu-active");
      });
  }
}

function fullSideMenuScroll() {
  /*
  $(".full-site-menu").niceScroll("ul", {
    cursorcolor: "#fff",
    cursorborder: "0px solid #3E3E3E",
    cursorborderradius: 0,
    smoothscroll: "TRUE",
    mousescrollstep: 30,
    scrollspeed: 120,
    bouncescroll: "FALSE",
  });
  */
}

/*----- WYSOKOSC FOOTER -----*/
function setFooterHeight() {
  $(".main-footer").css("min-height", "auto");

  const $wys_win = $(window).height();
  const $wys_wraper = $("#wrapper").outerHeight(true);
  // const $wys_footer = $(".main-footer").outerHeight(true);
  const $wys_decelowa_footer = $wys_win - $wys_wraper;
  if ($wys_decelowa_footer <= 0) {
    return;
  }
  $(".footer").css("min-height", $wys_decelowa_footer + "px");
}

/*----- POWIEKSZANIE ZDJEC -----*/
function powieksz_zdjecie() {
  const tab = $("a.powieksz");
  if (tab.length > 0) {
    $.colorbox.resize();
    $("a.powieksz").colorbox({
      initialWidth: 156,
      initialHeight: 80,
      maxWidth: "95%",
      maxHeight: "90%",
      scrolling: false,
      onComplete: function () {
        var $title = $(this).attr("title");
        $("body").find("img.cboxPhoto").attr("alt", $title);
      },
    });
  }
}

/*----- BANER GLOWNY -----*/
function baner_glowny() {
  $(".bxslider-baner-glowny").each(function () {
    $(this).bxSlider({
      adaptiveHeight: true,
      autoHover: true,
      auto: true,
      pause: 5000,
      pager: false,
      responsive: true,
      controls: true,
      touchEnabled: true,
    });
  });
}

/*----- CIASTECZKA -----*/
function akceptacja_ciasteczka() {
  $.post("/ciasteczka", { akceptacja: -1 }, function (data) {
    if (data == 1) {
      $("div.ciasteczka-info").hide();
    }
  });
  $("div.ciasteczka-info a.akceptuje-ciasteczka").click(function () {
    $.post("/ciasteczka", { akceptacja: 1 }, function () {});
    $("div.ciasteczka-info").fadeOut();
    return false;
  });
}
